import { set } from 'date-fns';

const combineDateTime = (date: Date, time: string): Date => {
  const [hoursRaw, minutesRaw] = (time || '00:00').split(':');
  const hours = Number(hoursRaw) || 0;
  const minutes = Number(minutesRaw) || 0;

  const combinedStartDate = set(date, {
    hours,
    minutes,
    seconds: 0,
    milliseconds: 0,
  });

  return combinedStartDate;
};

export default combineDateTime;
